module.exports = __webpack_public_path__ + "media/images/lb/649-6579ef2dd22713581520e5b61de60260.svg";